import { fromJS } from 'immutable';

import { INIT, INIT_SUCCESS, INIT_FAILED, SAVE_FAILED } from './constants';

export const initialState = fromJS({
  loading: false,
});

function formFormPageReducer(state = initialState, action) {
  switch (action.type) {
    case INIT:
      return state.merge({
        loading: true,
        activeStep: 0,
        uploadedFile: undefined,
      });

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, errorCode: action.errorCode });

    case SAVE_FAILED:
      return state.merge({ errorCode: action.errorCode });

    default:
      return state;
  }
}

export default formFormPageReducer;
